export const useStyles = (theme) => ({
  root: {
    fontSize: 100,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    flexDirection: "column",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  messageStyle: {
    textAlign: "center",
    color: "#fff",
    fontWeight: "bolder",
    fontFamily: "Open Sans",
  },
  link: {
    fontSize: 50,
    color: "#fff",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
});
